// extracted by mini-css-extract-plugin
export default {"cls1":"UserCard-cls1_iAG","cls2":"UserCard-cls2_wfa UserCard-cls1_iAG","small":"UserCard-small_z8p"};